import { useTranslation } from 'react-i18next';
import { PlanOverviewTabProps } from '../../../common/types/plan-overview-entity';
import {
    MenuWrapper,
    StyledCategory,
    StyledMenuItem,
    StyledSingleSelectMenuParent
} from '../../../themes/styles/plan-overview';

export const SingleSelectMenu = ({ tabItems, value, onChange, flat = false }: PlanOverviewTabProps) => {
    const { t } = useTranslation();
    if (tabItems?.length === 0) {
        return null;
    }

    const getGoalCategoryLabels = (category: string) => {
        const categoryLabels: Record<string, string> = {
            'Short Term': t('SHORT'),
            'Medium Term': t('MEDIUM'),
            'Long Term': t('LONG')
        };
        return categoryLabels[category] || category;
    };

    const groupByGoalCategory = tabItems?.reduce((acc, item) => {
        const category = item?.data?.goalCategory;
        if (!acc[`${category}-${item?.data?.goalCategoryOrder}`]) {
            acc[`${category}-${item?.data?.goalCategoryOrder}`] = [];
        }
        acc[`${category}-${item?.data?.goalCategoryOrder}`].push(item);
        return acc;
    }, {} as Record<string, typeof tabItems>);

    const sortedGroupByGoalCategory =
        !flat &&
        tabItems?.[0]?.data?.goalCategory &&
        Object.entries(groupByGoalCategory || {})
            .sort(([keyA], [keyB]) => {
                const orderA = parseInt(keyA.split('-')[1], 10);
                const orderB = parseInt(keyB.split('-')[1], 10);
                return orderA - orderB;
            })
            .reduce((acc, [key, value]) => {
                acc[key.split('-')[0]] = value;
                return acc;
            }, {} as Record<string, typeof tabItems>);

    return (
        <MenuWrapper>
            <StyledSingleSelectMenuParent>
                {!sortedGroupByGoalCategory &&
                    tabItems?.map((item, index) => (
                        <StyledMenuItem
                            key={index}
                            className={`${flat ? 'flat' : ''} ${index === value ? 'selected' : ''} ${
                                item?.disabled ? 'disabled' : ''
                            }`}
                            onClick={(event) => {
                                if (item?.disabled) return;
                                onChange(event, index);
                            }}
                            isFirst={index === 0}
                            isLast={index === (tabItems?.length || 1) - 1}
                            singleItem={tabItems?.length === 1}
                        >
                            {item.label}
                        </StyledMenuItem>
                    ))}
                {sortedGroupByGoalCategory &&
                    Object.entries(sortedGroupByGoalCategory as Record<string, typeof tabItems>).map(
                        ([category, items], $index) => (
                            <StyledCategory key={category}>
                                <div className={`category-label ${items?.[0]?.disabled ? 'disabled' : ''}`}>
                                    {getGoalCategoryLabels(category)}
                                </div>
                                {items?.map((item, index) => (
                                    <StyledMenuItem
                                        key={index}
                                        className={`${tabItems?.indexOf(item) === value ? 'selected' : ''} ${
                                            item?.disabled ? 'disabled' : ''
                                        }`}
                                        onClick={(event) => onChange(event, tabItems?.indexOf(item) || 0)}
                                        isLast={
                                            $index === Object.keys(sortedGroupByGoalCategory).length - 1 &&
                                            index === items.length - 1
                                        }
                                    >
                                        {item.label}
                                    </StyledMenuItem>
                                ))}
                            </StyledCategory>
                        )
                    )}
            </StyledSingleSelectMenuParent>
        </MenuWrapper>
    );
};
